"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Entry;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _EntryModule = _interopRequireDefault(require("./Entry.module.scss"));

var _Entry = _interopRequireDefault(require("./Entry.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Entry(_ref) {
  var entryComponent = _ref.entryComponent,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 0 : _ref$level,
      _ref$expPerc = _ref.expPerc,
      expPerc = _ref$expPerc === void 0 ? 0 : _ref$expPerc,
      _ref$isFocused = _ref.isFocused,
      isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused,
      _ref$isCombo = _ref.isCombo,
      isCombo = _ref$isCombo === void 0 ? false : _ref$isCombo,
      _ref$isComboUsable = _ref.isComboUsable,
      isComboUsable = _ref$isComboUsable === void 0 ? false : _ref$isComboUsable,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_EntryModule.default.entry, isFocused && _EntryModule.default.isFocused, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _EntryModule.default.component
  }, entryComponent), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_EntryModule.default.level, isCombo && !isComboUsable && _EntryModule.default.notUsable)
  }, !isCombo && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formatMessage(_Entry.default.levelPrefix), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: _EntryModule.default.value
  }, level)), isCombo && isComboUsable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formatMessage(_Entry.default.use)), isCombo && !isComboUsable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, formatMessage(_Entry.default.notUsable))), !isCombo && /*#__PURE__*/_react.default.createElement("div", {
    className: _EntryModule.default.expBar
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _EntryModule.default.fill,
    style: {
      width: "".concat(expPerc, "%")
    }
  })));
}